<lib-popup-toggle [icon]="SvgSpriteIcon.Sort" data-test="sorting-selector">
  <lib-buttons-select
    [options]="sortingOptions"
    keyName="label"
    optionLabel="label"
    optionDataAttr="sortingType"
    [ngModel]="selectedSorting()"
    (ngModelChange)="updateSelectedSorting($event)"
  />
</lib-popup-toggle>
